import { DOMAIN } from "constants/base"
import { apiGetHelper, apiPostHelper, domain } from "utils/apiHelper"

export const fireUrl = async (url) => {
    try {
      const response = apiGetHelper(url, 'application/json')
      return response
    } catch (e) {
      console.error(e)
    }
  }

  export const fetchFccAds =  (payload) => {
    try {
      const URL = `${DOMAIN}/monetisation/requestAd`
      const header = {
        caller: domain
      }
      const response = apiPostHelper(URL,payload, 'application/json',header)
    
      return response
    } catch (e) {
      console.error(e)
    }
  }